const ClarificationOptions = ({ options = [], onSelect, disabled }) => {
  if (!options.length) return null;
  return (
    <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2">
      {options.map((opt, idx) => {
        const label = opt.display_name || opt.name || opt.label || opt.id || `Option ${idx + 1}`;
        const sub = [opt.current_employer, opt.location].filter(Boolean).join(' • ');
        return (
          <button
            key={opt.id || label + idx}
            type="button"
            onClick={() => onSelect(label)}
            disabled={disabled}
            className="flex flex-col items-start rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-left text-sm text-slate-100 hover:bg-white/10 disabled:opacity-60"
          >
            <span className="font-semibold">{label}</span>
            {sub ? <span className="text-xs text-slate-400">{sub}</span> : null}
          </button>
        );
      })}
    </div>
  );
};

export default ClarificationOptions;
